import { useEffect, useRef } from 'react';

interface AudioTrackProps {
  stream: MediaStream | null;
  autoMute: boolean;
}
/**
 * Component that handles adding/removing an audio stream based on the audioStream prop. The audio element is muted to prevent echo
 * @param {MediaStream | null} props.stream - MediaStream
 * @param {Boolean} props.autoMute - Flag for muting the audio player
 */
const AudioTrack = ({ stream, autoMute = false }: AudioTrackProps) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audioRefCurrent = audioRef.current;

    if (stream && audioRefCurrent) {
      audioRef.current.srcObject = stream;
    }

    return () => {
      if (audioRefCurrent) {
        (async () => {
          const audioStream = stream?.getAudioTracks()?.[0];
          if (audioStream) {
            audioStream.stop();
          }
        })();
      }
    };
  }, [stream]);

  return <audio ref={audioRef} autoPlay muted={autoMute} />;
};

export default AudioTrack;
